export default __webpack_public_path__ + "static/media/ivy_transportation.815f437b.png";